import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../theme";
import KeyboardArrowUp from "@mui/icons-material/KeyboardArrowUp";

interface Props {
  inProgressCount: number;
  completeCount: number;
  onExpand: () => void;
  overdueCount: number;
}

const UpcomingFeaturesMinimisedPill = ({
  inProgressCount,
  completeCount,
  onExpand,
  overdueCount,
}: Props) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      onClick={onExpand}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        px: 2.5,
        py: 1.2,
        borderRadius: "999px",
        cursor: "pointer",
        backgroundColor: colors.primary[800],
        border: `1px solid ${colors.primary[300]}30`,
        "&:hover": { backgroundColor: colors.primary[800] },
      }}
    >
      <Typography
        sx={{
          fontSize: "0.75rem",
          fontWeight: 700,
          color: colors.primary[100],
          letterSpacing: "0.08em",
        }}
      >
        UPCOMING FEATURES
      </Typography>
      <Box
        sx={{ width: "1px", height: 14, backgroundColor: colors.primary[600] }}
      />
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            backgroundColor: "#E11D48",
          }}
        />
        <Typography sx={{ fontSize: "0.7rem", color: colors.primary[100] }}>
          {overdueCount} overdue
        </Typography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            backgroundColor: "#f0b445",
          }}
        />
        <Typography sx={{ fontSize: "0.7rem", color: colors.primary[100] }}>
          {inProgressCount} in progress
        </Typography>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            backgroundColor: "#4ecb8d",
          }}
        />
        <Typography sx={{ fontSize: "0.7rem", color: colors.primary[100] }}>
          {completeCount} complete
        </Typography>
      </Box>
      <Box
        sx={{ width: "1px", height: 14, backgroundColor: colors.primary[600] }}
      />

      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation(); // prevent double-firing with parent onClick
          onExpand();
        }}
        sx={{
          color: colors.primary[100], // use a lighter color, same as the text
          p: 0.5,
          ml: -0.5,
          flexShrink: 0, // prevent it from being squeezed out
          "&:hover": { color: "white", backgroundColor: "transparent" },
        }}
      >
        <KeyboardArrowUp sx={{ fontSize: 18 }} />
      </IconButton>
    </Box>
  );
};

export default UpcomingFeaturesMinimisedPill;
